import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "daf36083-237f-4abc-b35a-b8c76538bc28",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "dd33a16c-811f-4954-a8a5-32234bf1f80a",
      type: "Sprite",
      name: "item",
      nameSpace: "",
      className: "small_fireplace",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "small_fireplace",
      parent: "daf36083-237f-4abc-b35a-b8c76538bc28",
      data: ""
    }
  ]
} as const;

export class SmallFireplaceLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  item: GameObject<PIXI.Sprite>;
  small_fireplace: (GameObject<PIXI.Sprite>)[];

  constructor() {
    populate(this, raw);
  }
}
